








import Vue from "vue";
import DataContainer from "@vuetifyx/common/DataContainer";
import coreApiClient from "@/services/apis/coreApiClient";
import makeSelectOptions from "@common/util/makeSelectOptions";
import Loading from "@/components/Loading.vue";
import { VueEditor } from "vue2-editor";

export default Vue.extend({
  components: { Loading },
  data() {
    const docId = this.$route.query.id;
    return {
      docId,
      dataContainer: new DataContainer(),
      formOptions: {
        attrs: {
          title: docId ? "Edit Doc" : "Create Doc",
        },
        content: {
          ignoreOtherFields: true,
          sections: {
            default: {
              fields: {
                name: {
                  attrs: {
                    label: "Name",
                    required: true,
                  },
                },
                content: {
                  type: VueEditor,
                  attrs: {
                    label: "Content",
                    required: true,
                  },
                },
                language: {
                  type: "select",
                  attrs: {
                    label: "Language",
                    required: true,
                    items: makeSelectOptions({
                      en: "English",
                      vi: "Vietnamese",
                    }),
                  },
                },
                disabled: {
                  type: "boolean",
                  attrs: {
                    label: "Disabled",
                  },
                },
              },
            },
          },
          actionButtons: {
            save: {
              content: {
                text: "Save",
              },
              on: {
                async xClick({ self }) {
                  const form = self.context();
                  const data = form.getData();
                  form.loading.value = true;
                  self.loading.value = true;

                  if (docId) {
                    await coreApiClient.call("docs", "update", { id: docId }, {
                      data,
                    });
                  } else {
                    await coreApiClient.call("docs", "create", undefined, data);
                  }

                  self.loading.value = false;
                  form.loading.value = false;
                  form.success.value = "Doc saved successfully";

                  setTimeout(() => {
                    self.$router.push("/app/settings/docs");
                  }, 1000);
                },
              },
            },
            cancel: {
              content: {
                text: "Cancel",
              },
              on: {
                xClick({ self }) {
                  self.$router.push("/app/settings/docs");
                },
              },
            },
          },
        },
      },
      formContainer: new DataContainer(),
    };
  },
  async created() {
    if (this.docId) {
      const data = await coreApiClient.call("docs", "findById", { id: this.docId });
      this.dataContainer.value = data;
    } else {
      this.dataContainer.value = {
        name: "",
        content: "",
        language: "en",
        disabled: false,
      };
    }
  },
});
